import * as React from 'react';
import "./subscription.css";
import {Box, Card, Checkbox, Divider, Stack, TextField, Typography} from "@mui/material";
import {useEffect} from "react";

const SubscriptionFailed = ({setShowNav}) => {
    useEffect(() => {
        setShowNav(true);
    }, [])

    return (
        <Stack direction="row" justifyContent="center" alignItems="center" padding={7}>
            <Card className={"detail-card"} sx={{padding:2}}>
                <Stack padding={1} direction={"column"} alignItems={"center"}>
                    <Typography variant={'h4'} sx={{color:'#263238'}}>Votre paiement a échoué</Typography>
                </Stack>
                <Divider />
                <Stack direction="column" justifyContent="center" alignItems="flex-start" padding={2}>
                    <Typography>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis viverra consequat ultricies vulputate id sit elit eget. Ultricies sed pellentesque amet, egestas turpis nunc aliquam.</Typography><br/>
                    <button className={'validationButton'}>Revenir à l'accueil</button>
                </Stack>
            </Card>
        </Stack>
    )
}

export default SubscriptionFailed;
